import { authHeader } from '@/_helpers'

export const monitorService = {
  getMonitorList,
  getMonitorUser,
  getClients,
  getAccountEmails,
  getAccountEmailsTotal,
  getAccountEmailsFilters,
  getAccountEmailsStats,
  getApolloEnrich,
  getEmailsConfigSmtp,
  getClientWithoutOliverSales,
  getStatsBdrMetrics,
  getInvoiceControl,
  getListDeleteDomains,
  changeStatusDomainDelete,
  getInvoiceControlByWorkspace,
}

const apiUrl = process.env.VUE_APP_ROOT_API

function getMonitorList(team_id, searchFilter, target_id = 0) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ team_id, searchFilter, target_id }),
  }

  return fetch(`${apiUrl}/users/monitorlist/${team_id}`, requestOptions).then(
    handleResponse,
  )
}

function getInvoiceControlByWorkspace() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
    body: JSON.stringify(),
  }

  return fetch(`${apiUrl}/admin/invoice-control-by-workspace`, requestOptions)
    .then(handleResponse)
}

function getInvoiceControl() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
    body: JSON.stringify(),
  }

  return fetch(`${apiUrl}/admin/invoice-control`, requestOptions)
    .then(handleResponse)
}

function getStatsBdrMetrics(option, range) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
    body: JSON.stringify(),
  }

  return fetch(`${apiUrl}/users/get-stats-bdr-metrics?option=${option}&start_date=${range.startDate}&end_date=${range.endDate}`, requestOptions)
    .then(handleResponse)
}



function getEmailsConfigSmtp(active, count = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
    body: JSON.stringify(),
  }

  return fetch(`${apiUrl}/clients/get-emails-config-smtp?count=${count}&active=${active}`, requestOptions)
    .then(handleResponse)
}

function getClientWithoutOliverSales(active, count = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
    body: JSON.stringify(),
  }

  return fetch(`${apiUrl}/clients/get-client-without-oliver-sales?count=${count}&active=${active}`, requestOptions)
    .then(handleResponse)
}

function getClients(team_id = null, clientStatus = 0, toCreateUser = 0, subscriptionPlanVersion = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }

  return fetch(`${apiUrl}/users/clientsagency?clientStatus=${clientStatus}&toCreateUser=${toCreateUser}&subscriptionPlanVersion=${subscriptionPlanVersion}`, requestOptions).then(
    handleResponse,
  )
}

function getMonitorUser(user_id, type, range, groupBy, plan_id = '0') {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ user_id, type, range, groupBy, plan_id }),
  }
  return fetch(`${apiUrl}/users/monitor`, requestOptions).then(handleResponse)
}

function getListDeleteDomains(params) {

  const queryString = new URLSearchParams({
    ...params
  }).toString();

  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }

  return fetch(`${apiUrl}/admin/get-list-domains-to-delete?${queryString}`, requestOptions)
    .then(handleResponse) 
  }

function getApolloEnrich(q) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({q}),
  }
  return fetch(`${apiUrl}/clients/apollo-enrich`, requestOptions).then(handleResponse)
}

function getAccountEmails(params) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ params }),
  }
  return fetch(`${apiUrl}/clients/get-account-emails`, requestOptions).then(
    handleResponse,
  )
}

function getAccountEmailsTotal(params) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ params }),
  }
  return fetch(
    `${apiUrl}/clients/get-account-emails-total`,
    requestOptions,
  ).then(handleResponse)
}

function getAccountEmailsFilters() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({}),
  }
  return fetch(
    `${apiUrl}/clients/get-account-emails-filters`,
    requestOptions,
  ).then(handleResponse)
}

function getAccountEmailsStats(params) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ params }),
  }
  return fetch(`${apiUrl}/clients/get-account-emails-stats`, requestOptions).then(
    handleResponse,
  )
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        logout()
      }

      const error = data || response.statusText
      return Promise.reject(error)
    }

    return data
  })
}

function changeStatusDomainDelete(domain, suppressed) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ domain, suppressed }),
  }

  return fetch(`${apiUrl}/admin/change-status-domain-delete`, requestOptions)
    .then(handleResponse)
}
